import React from 'react';
import DashboardLayout from '../../components/dashboard/DashboardLayout';

const NicheJobBoards = () => {
  const jobBoards = [
    { category: "Creative", boards: [
        { name: "FlexJobs", link: "https://www.flexjobs.com/", description: "Thousands of Remote Jobs -Worldwide" },
        { name: "Authentic Jobs", link: "https://authenticjobs.com/", description: "The leading job board for designers, developers, and creative pros." },
        { name: "Art Jobs", link: "https://www.artjobs.com/", description: "The community for the arts, culture, design, entertainment and creative industries." },
        { name: "Behance", link: "https://www.behance.net/joblist", description: "Creative Jobs List" },
        { name: "Dribbble", link: "https://dribbble.com/jobs", description: "#1 job board for graphic designers" },
        { name: "We Work Remotely", link: "https://weworkremotely.com/", description: "Remote Work Job Board -Worldwide" },
        { name: "Coroflot", link: "https://www.coroflot.com/", description: "Job Board for All Designers - Any Industry Worldwide (Can attach portfolio)" },
        { name: "AIGA", link: "https://designjobs.aiga.org/", description: "Freelance to Executive Level Roles including Professorships" },
      ]
    },
    { category: "Media Jobs", boards: [
        { name: "Media Bistro", link: "https://www.mediabistro.com/", description: "Graphic Designers, Copywriters, Social Media Managers, Producers & More" },
        { name: "CunjunBoard", link: "https://www.cunjunboard.com/", description: "Tech, Earth and Engineering Jobs" },
        { name: "Media Recruiter", link: "https://www.mediarecruiter.com/", description: "Largest list of media positions nationwide" },
        { name: "Media Match", link: "https://www.media-match.com/", description: "Film and TV Jobs in USA" },
        { name: "PR News Online", link: "https://www.prnewsonline.com/", description: "Professional development, community events, awards and communications resources, and Job" },
      ]
    },
    { category: "Start Up Jobs", boards: [
        { name: "Well Found", link: "https://wellfound.com/jobs", description: "Over 130k remote & local startup jobs" },
        { name: "Start Up Jobs", link: "https://startupjobs.com/", description: "Start Ups and Companies that are in growth mode" },
        { name: "Venture Loop", link: "https://www.ventureloop.com/", description: "Job Board for Venture Capital Firms looking for talent" },
        { name: "Hacker News", link: "https://news.ycombinator.com/jobs", description: "Jobs related to entrepreneurship and computer science - Job board hosted by combinator" },
        { name: "Hire Art", link: "https://www.hireart.com/", description: "Job board for startups" },
        { name: "Start Up Job List", link: "https://startupjoblist.com/", description: "Start Up Tech Jobs in California" },
        { name: "StartUp 100 (NYC & SFO)", link: "https://startup100.com/", description: "Job board for AI, Gaming, all things Tech, Engineering, some business roles" },
      ]
    },
    { category: "Tech Jobs", boards: [
        { name: "Dice", link: "https://www.dice.com/", description: "Premier Job Board for Tech & Data Jobs" },
        { name: "iCrunchData", link: "https://www.icrunchdata.com/", description: "Stack Overflow Careers is a job board serving programmers and engineers." },
        { name: "Tech Careers", link: "https://www.techcareers.com/", description: "Tech jobs - continuously updating" },
        { name: "IT Job Pro", link: "https://www.itjobpro.com/", description: "IT job board with listings in USA, Europe, Asia, Australia, New Zealand" },
        { name: "Tech Fetch", link: "https://www.techfetch.com/", description: "100K jobs & 6,000 Recruiters" },
      ]
    },
    { category: "Legal Jobs", boards: [
        { name: "Law.com", link: "https://www.law.com/", description: "Resource for legal jobs in the US" },
        { name: "Law Match", link: "https://www.lawmatch.com/", description: "Attorneys, Law Clerks, Paralegals, and Law Students" },
        { name: "Casetext", link: "https://casetext.com/", description: "Lawyers, Law Clerks, Paralegals, and Law Students" },
        { name: "NALP", link: "https://www.nalp.org/", description: "Legal Jobs Nationwide" },
        { name: "Legal Job Network", link: "https://www.legaljobnetwork.com/", description: "Legal Jobs Nationwide" },
        { name: "Above the Law", link: "https://abovethelaw.com/", description: "Legal news website and job board" },
      ]
    },
    { category: "Restaurant / Hospitality", boards: [
        { name: "Hospitality Online", link: "https://www.hospitalityonline.com/", description: "One of largest hospitality food boards - restaurants, hotels, resort jobs" },
        { name: "H Careers", link: "https://www.hcareers.com/", description: "All hospitality jobs" },
        { name: "Hire Hospitality", link: "https://www.hirehospitality.com/", description: "Hospitality jobs everywhere" },
        { name: "Poached Jobs", link: "https://poachedjobs.com/", description: "Hospitality jobs everywhere" },
        { name: "Go Hire", link: "https://www.gohire.com/", description: "Hospitality Job Boards" },
        { name: "HOSCO", link: "https://www.hosco.com/en/jobs", description: "50,000 + Hospitality Jobs Worldwide" },
        { name: "The Restaurant Zone", link: "https://www.therestaurantzone.com/", description: "Restaurant Job board" },
      ]
    },
    { category: "Finance Jobs", boards: [
        { name: "Financial Careers", link: "https://www.financialcareers.com/", description: "Financial Services and Technology Jobs" },
        { name: "Broker Hunter", link: "https://www.brokerhunter.com/", description: "Thousands of financial jobs" },
        { name: "Financial Job Network", link: "https://www.financialnetwork.com/", description: "Global Financial Jobs" },
        { name: "Finance Jobs.net", link: "https://www.financejobs.net/", description: "Financial Job Board" },
        { name: "American Finance Assoc. (AFA)", link: "https://careers.afajof.com/", description: "Academia, Finance, Government Jobs" },
      ]
    },
    { category: "Government Jobs", boards: [
        { name: "Government Jobs", link: "https://www.governmentjobs.com/", description: "Nationwide Government Jobs" },
        { name: "USA Jobs", link: "https://www.usajobs.gov/", description: "USA Jobs - Students, Civilians, Fed Workers, Veterans" },
        { name: "Career One Stop", link: "https://www.careeronestop.org/", description: "Jobs, Training, Exploration" },
        { name: "Political Job Hunt", link: "https://www.politicaljobhunt.com/", description: "Political Jobs" },
      ]
    },
    { category: "Internships", boards: [
        { name: "Internships.com", link: "https://www.internships.com/", description: "Internship listings" },
        { name: "College Recruiter", link: "https://www.collegerecruiter.com/", description: "Students and Recent grads" },
        { name: "Career Rookie", link: "https://www.careerrookie.com/", description: "New Grads" },
        { name: "Career One Stop", link: "https://www.betterteam.com.au/graduates", description: "Australia Only" },
      ]
    },
    { category: "Sales", boards: [
        { name: "Sales Jobs", link: "https://www.salesjobs.com/", description: "USA based Sales Jobs" },
        { name: "Sales Jobs Worldwide", link: "https://www.salesjobs.com/sales-jobs", description: "Sales Jobs" },
        { name: "The LIONS", link: "https://www.thelions.com/", description: "Tech Sales" },
      ]
    },
    { category: "Healthcare Jobs", boards: [
        { name: "Healthcare Jobs Nationwide", link: "https://www.healthcarejobs.com/", description: "Healthcare jobs nationwide" },
        { name: "Bio Space", link: "https://jobs.biospace.com/search/job/", description: "Medical, Academic, Pharma, Bio, Research, Clinical" },
        { name: "ASHP", link: "https://careers.ashp.org/", description: "Pharmacist jobs" },
      ]
    },
    { category: "Construction", boards: [
        { name: "RIG ZONE", link: "https://www.rigzone.com/", description: "Oil and Gas Jobs" },
        { name: "Construction Jobs", link: "https://www.constructionjobs.com/", description: "Traveling contractor jobs" },
        { name: "HIS Construction", link: "https://www.hisconstruction.com/", description: "Construction Jobs" },
        { name: "Careers in Construction", link: "https://www.careersinconstruction.com/", description: "Construction Jobs" },
      ]
    },
    { category: "Retail", boards: [
        { name: "Retail Jobs", link: "https://www.retailjobs.com/", description: "Retail Jobs" },
        { name: "Retail Crossings", link: "https://www.retailcrossing.com/", description: "Retail Advisors and Managers" },
        { name: "All Retail Jobs", link: "https://www.allretailjobs.com/", description: "Fashion Only Jobs" },
        { name: "Grocery Jobs", link: "https://www.groceryjobs.com/", description: "Grocery Supermarket Jobs" },
      ]
    },
    { category: "Education", boards: [
        { name: "Ed Join", link: "https://www.edjoin.com/", description: "Nation's #1 Education Job Board" },
        { name: "Higher Ed Jobs", link: "https://www.higheredjobs.com/", description: "Higher Education Job" },
        { name: "Teach Spring", link: "https://www.teachspring.com/", description: "Teaching Abroad" },
        { name: "US Department of Education", link: "https://www.ed.gov/", description: "Job board lists public schools with vacancies throughout the United States" },
      ]
    },
    { category: "Other Job Boards", boards: [
        { name: "Ladders", link: "https://www.theladders.com/", description: "Job board for positions paying over $100,000" },
        { name: "Ready Set Hire", link: "https://www.readysethire.com/", description: "Thousands of underprivileged jobs" },
        { name: "Tech Jobs", link: "https://www.techjobs.com/", description: "All Types of Jobs Worldwide" },
      ]
    },
  ];

  return (
    <DashboardLayout>
      <div className="max-w-6xl mx-auto px-6 py-12 text-gray-800">
        <h1 className="text-4xl font-bold mb-8">Niche Job Boards</h1>
        <div className="space-y-8">
          {jobBoards.map((category) => (
            <div key={category.category}>
              <h2 className="text-2xl font-semibold mb-4">{category.category}</h2>
              <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="py-2 px-4 text-left">Job Board</th>
                    <th className="py-2 px-4 text-left">Description</th>
                  </tr>
                </thead>
                <tbody>
                  {category.boards.map((board) => (
                    <tr key={board.name} className="border-b hover:bg-gray-50">
                      <td className="py-2 px-4">
                        <a href={board.link} className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">
                          {board.name}
                        </a>
                      </td>
                      <td className="py-2 px-4">{board.description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default NicheJobBoards;